import {useEffect, useRef, useCallback} from "react";
import {reportEventQueue} from "./logService";

export function isMovil() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function useEffectOnce(callback) {
    const isFirstRender = useRef(true);
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    });

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            callbackRef.current();
        }
    }, []);
}
export function createElementImage(capturedDataUrl, rotate = true, callback) {
    return new Promise(async (resolve, reject) => {
        try {
            const byteCharacters = atob(capturedDataUrl.split(",")[1]);
            const byteArrays = [];

            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays.push(byteCharacters.charCodeAt(i));
            }

            const byteArray = new Uint8Array(byteArrays);
            const blob = new Blob([byteArray], { type: "image/jpeg" });

            // Obtener la URL del Blob
            const blobURL = URL.createObjectURL(blob);

            // Crear un elemento img
            // const imageref = document.getElementById("imgResult")
            const imgElement = document.createElement('img');

            // Establecer atributos del elemento img
            imgElement.src = blobURL;
            imgElement.alt = 'Descripción de la imagen';
            imgElement.style.display = 'none'
            if (isMovil() && rotate) {
                const deg = -90
                imgElement.style.webkitTransform = 'rotate('+deg+'deg)';
                imgElement.style.mozTransform    = 'rotate('+deg+'deg)';
                imgElement.style.msTransform     = 'rotate('+deg+'deg)';
                imgElement.style.oTransform      = 'rotate('+deg+'deg)';
                imgElement.style.transform       = 'rotate('+deg+'deg)';
            }
            const container = document.getElementById('root'); // reemplaza 'container' con el ID de tu contenedor
            container.appendChild(imgElement);
            let responseCallback = false
            if (callback) {
                setTimeout(async () => {
                    responseCallback = await callback(imgElement)
                    resolve({imgElement, responseCallback})
                }, 200)
            } else {
                resolve(imgElement)
            }

        }catch (e) {
            reject(e)
        }
    })
}
export const initDevice = () => {
    let device = {
        isMobile: false,
        isAndroid: false,
        isLinux: false,
        isMac: false,
        isWin: false,
        isChrome: false,
        isFirefox: false,
        isSafari: false,
        isIos: false
    };
    device.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    device.isAndroid = /Android/i.test(navigator.userAgent);
    device.isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    device.isLinux = /linux/i.test(navigator.platform);
    device.isMac = /mac/i.test(navigator.platform);
    device.isWin = /win/i.test(navigator.platform);
    device.isChrome = /chrome/i.test(navigator.userAgent);
    device.isFirefox = /firefox/i.test(navigator.userAgent);
    device.isSafari = !device.isChrome
        ? /safari/i.test(navigator.userAgent)
        : false;
    device.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    device.isAndroid = /Android/i.test(navigator.userAgent);
    device.isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (!device.isIos) {
        const isIPad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
        if (isIPad) {
            device.isIos = true;
            device.isMobile = true;
        }
    }
    return device;
};
export const getConstraints = (isMac, cameraType) => {
    return isMac ?
        {
            audio: false,
            video: {
                facingMode: cameraType,
                width: 1280,
                height: 720
            }
        } : {
            audio: false,
            video: {
                facingMode: cameraType,
                width: { ideal: 1920 }, // 1920
                height: { ideal: 1080 }, // 1080
                focusMode: 'continuous'
            }
        };
};
export const blobToBase64 = (blob) => {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
};
export function videoRatio(videoElement) {
    const hRatio = videoElement.clientWidth / videoElement.videoWidth;
    const vRatio = videoElement.clientHeight / videoElement.videoHeight;
    return Math.min(hRatio, vRatio);
}
export function getVideoRatio(videoElement) {
    const hRatio = videoElement.clientWidth / videoElement.videoWidth;
    const vRatio = videoElement.clientHeight / videoElement.videoHeight;
    return Math.min(hRatio, vRatio);
}

export function reportEvent(url, processId, eventType, message = {}, processType = 'CardCapture') {
    return new Promise(async (resolve, reject) => {
        try {
            resolve(reportEventQueue(url, processId, eventType, message, processType));
        } catch (e) {
            reject(e)
        }
    })
}
